<script>
import {transaction as transactionColumns} from '../../tables'
import { serviceColors, statusColors, service, status } from "../../config/transaction"

export default {
  props: {
    client_id: {
      type: String,
      default: ''
    },
    path: {
      type: String,
      default: ''
    },
    showFilter: {
      type: Boolean,
      default: true
    },
    listening: {
      type: Boolean,
      default: true
    },
    excludes: {
      type: Array,
      default: () => []
    },
    filters: {
      type: Object,
      default: () => ({
        q: null,
        page: 1,
        per_page: 10,
        date: [],
        status: [],
        billers: [],
        service: [],
        clients: [],
        products: []
      })
    },
  },
  computed: {
    serviceColors,
    statusColors,
    drawerVisible() {
      return this.drawerStatus.filtering || this.drawerStatus.editing
    },
    columns() {
      return _.filter(transactionColumns, (o) => ! this.excludes.includes(o.key))
    },
    uri() {
      return (this.path !== '') ? this.path : this.routeUri('hyperion.transaction')
    },
    pageSize() {
      return parseInt(this.items.per_page)
    },
    pagination() {
      return { pageSize: this.pageSize, current: this.items.current_page, total: this.items.total, showSizeChanger: true }
    },
    exportUri() {
      if(this.client_id){
        this.filters.clients.push(this.client_id)
      }

      let params = _.merge(this.filters, {
        timestamp: (new Date).getTime()
      })

      return this.routeUri('hyperion.transaction.export') + '?' + this.$qs.stringify(params)
    },
    downloadCondition() {
      return this.filters.date.length === 0 || this.filters.service.length === 0
    }
  },
  data() {
    return {
      service,
      status,
      items: {},
      downloadWarningVisibility: false,
      loading: false,
      modal: {
        visible: false,
        item: {}
      },
      patching: [],
      newCounter: 0,
      editing: null,
      drawerStatus: {
        filtering: false,
        editing: false
      },
      loadingDownload: false
    }
  },
  created() {
    this.items = this.getDefaultPagination()
    this.filters = _.merge(this.filters, this.$hyperion.request)
    this.getItems()

    this.$emit('filtered', this.filters)
  },
  mounted() {
    if (this.listening)
      this.registerListeners()
  },
  methods: {
    tableChanged(pagination) {
      this.filters.page = pagination.current
      this.filters.per_page = pagination.pageSize
      this.newCounter = 0
      this.pushState(this.filters)
      this.getItems()
    },
    getItems() {
      this.newCounter = 0
      this.loading = true
      this.$emit('updating', this.filters)
      this.$http.get(this.routeUri(this.uri, {}, true), {
        params: this.filters
      })
        .then((response) => this.items = response.data)
        .catch((error) => this.handleXhrError(error))
        .finally(() => this.loading = false)
    },
    patchTransaction(transactionId, action) {
        this.patching.push(transactionId)
        this.$http.patch(this.routeUri('hyperion.transaction.patch', { transaction_uuid: transactionId}), {
          action: action // 'RESEND_CALLBACK'
        })
        .then(() => window.location.reload())
        .catch((error) => this.handleXhrError(error))
    },
    handleDownload(e) {
      this.downloadWarningVisibility = false
      // window.open(this.exportUri, '_blank')
      this.loadingDownload = true

      if(this.client_id){
        this.filters.clients.push(this.client_id)
      }

      let params = _.merge(this.filters, {
        timestamp: (new Date).getTime(),
        format: e.key
      })

      this.$http.get(this.routeUri('hyperion.transaction.export') + '?' + this.$qs.stringify(params))
      .then(() => this.handleSuccessResponse())
      .catch((error) => this.handleResponseError(error))
      .finally(() => this.loadingDownload = false)
    },
    handleSuccessResponse(data) {
      this.$notification.success({
        message: 'Proccess!',
        description: 'Data has been processed!'
      })
    },
    handleResponseError(data) {
      this.$notification.error({
        message: "Failed to export data",
        description: data.message
      })
    },
    handleWarningVisibility(visible) {
      if (!visible) {
        this.downloadWarningVisibility = false
        return
      }
      if (!this.downloadCondition) {
        this.handleDownload()
      } else {
        this.downloadWarningVisibility = true
      }
    },
    registerListeners() {
      Echo.private('hyperion-monitoring-transaction')
        .listen('Services.InquiryRequestAccepted', (e) => this.newCounter++)
        .listen('Services.PaymentRequestAccepted', (e) => this.newCounter++)
    },
    refresh() {
      this.$emit('filtered', this.filters)
      this.getItems()
    },
    closeDrawer() {
      this.drawerStatus.filtering = false
      this.drawerStatus.editing = false
      this.editing = null
    },
    filtered(filters) {
      Object.assign(this.filters, filters)
      // this.drawerStatus.filtering = false
      this.pushState(this.filters)

      this.$emit('filtered', this.filters)
      this.getItems()
    },
    edit(record) {
      this.editing = record
      this.drawerStatus.editing = true
    }
  },
}
</script>
<template>
  <div>
    <a-alert type="info" v-if="newCounter > 0 && listening" style="margin-bottom: 24px;">
      <span slot="description">There are total of <strong>{{ newCounter }}</strong> New Transaction(s) since you opened this page, click to <a href="javascript:void(0)" @click="refresh">refresh</a>.</span>
    </a-alert>

    <a-card size="small" type="inner">
      <div slot="extra">
        <a-dropdown>
          <a-menu slot="overlay" @click="handleDownload">
            <a-menu-item key="xlsx">
              <a-icon type="file-excel" theme="twoTone" two-tone-color="#52c41a"/> XLSX
            </a-menu-item>
            <a-menu-item key="csv">
              <a-icon type="file-text" theme="twoTone"/> CSV
            </a-menu-item>
          </a-menu>
          <a-button class="ml-2" size="small" type="primary" icon="cloud-download" :loading="loadingDownload"/>
        </a-dropdown>

        <a-button size="small" icon="filter" title="Filter Form" @click="() => drawerStatus.filtering = true" />
      </div>

      <a-skeleton :loading="loading" active>
        <a-table :columns="columns" :dataSource="items.data" rowKey="id" :pagination="pagination" @change="tableChanged" :scroll="{ x: 3500, y: 700 }">

          <h5 slot="datetime" slot-scope="datetime" class="text-center">
            {{ moment(datetime).format('DD/MM/YYYY HH:mm:ss') }}
          </h5>

          <h5 slot="customer_number" slot-scope="record">
            {{ record.customer_number }}
          </h5>

          <h5 slot="customer_name" slot-scope="record">
            {{ record.customer_name }}
          </h5>

          <h5 slot="pan" slot-scope="record">
            {{ record.pan }}
          </h5>

          <h5 slot="card_acceptor_name" slot-scope="record">
            {{ record.card_acceptor_name }}
          </h5>

          <h5 slot="account_number_merchant" slot-scope="record">
            {{ record.account_number_merchant }}
          </h5>

          <h5 slot="merchant_type" slot-scope="record">
            {{ record.client.merchant_type }} - {{ record.client.name }}
          </h5>

          <h5 slot="tid" slot-scope="record">
            {{ record.tid }}
          </h5>

          <h5 slot="mid" slot-scope="record">
            {{ record.mid }}
          </h5>

          <h5 slot="batch_number" slot-scope="record">
            {{ record.batch_number }}
          </h5>

          <h5 slot="branch_code" slot-scope="record">
            {{ record.branch_code }}
          </h5>

          <h5 slot="stan" slot-scope="record">
            {{ record.stan }}
          </h5>

          <h5 slot="rrn" slot-scope="record">
            {{ record.rrn }}
          </h5>

          <h5 slot="product_name" slot-scope="record">
            {{ record.product.name }}
          </h5>

          <h5 slot="product_code" slot-scope="record">
            {{ record.product.code }}
          </h5>

          <div slot="biller" slot-scope="record">
            <template v-if="record.biller !== null">
              <h4>
                <a :href="routeUri('hyperion.biller.show', { biller_hash : record.biller.hash })"><a-icon type="deployment-unit" /> {{ record.biller.name }}</a>
              </h4>
            </template>
            <template v-else>
              <div class="text-muted">
                <em>none</em>
              </div>
            </template>
          </div>

          <h5 slot="driver" slot-scope="record">
            {{ record.driver }}
          </h5>

          <div slot="client" slot-scope="record">
            <h4>
              <a-tooltip :title="record.name">
                <a :href="routeUri('hyperion.client.show', { client_hash: record.client.hash })"><a-icon type="solution" /> {{ record.client.username }}</a>
                <br>
              </a-tooltip>
            </h4>
          </div>

          <h5 slot="subscriber_id" slot-scope="record">
            {{ record.subscriber_id }}
          </h5>

          <div slot="amount" slot-scope="record">
            <currency :amount="record.biller_price" />
          </div>

          <div slot="denomination" slot-scope="record">
            <currency :amount="record.denomination" />
          </div>

          <div slot="ref_number" slot-scope="record">
            {{ record.ref_num }}
          </div>

          <div slot="serial_number" slot-scope="record">
            {{ record.serial_number }}
          </div>

          <div slot="service" slot-scope="service_type" :style="{textAlign: 'center'}">
            <h4 :style="{ color: serviceColors[service_type] }">{{ service_type.toUpperCase() }}</h4>
          </div>

          <h4 slot="biller_price" slot-scope="record" class="text-center">
            <currency :amount="record.price" />
          </h4>

          <h4 slot="profit" slot-scope="record" class="text-center">
            <currency :amount="(record.price - record.biller_price)" />
          </h4>

          <h5 slot="response_code" slot-scope="record">
            {{ record.response_code }}
          </h5>

          <span slot="status" slot-scope="record" class="text-center">
            <a-tooltip placement="top">
              <template slot="title">{{ record.rc_description }}</template>
              <a-tag :color="statusColors[record.status]">
                {{ record.status.toUpperCase() }}
              </a-tag>
            </a-tooltip>
          </span>

          <div class="text-right" slot="action" slot-scope="record">
            <template v-if="record.service_type === service.TRANSACTION_SERVICE_PAYMENT">
              <a-tooltip title="Edit Status">
                <!-- <a-button :loading="patching.includes(record.id)" size="small" type="danger" icon="edit" @click="edit(record)"/> -->
                <a-button size="small" type="danger" icon="edit" target="_blank" :href="routeUri('hyperion.transaction.edit', { transaction_uuid: record.id })"/>
              </a-tooltip>

              <template v-if="record.status === 'success'">
                <a-tooltip title="Resend Callback">
                  <a-button :loading="patching.includes(record.id)" size="small" type="primary" icon="retweet" @click="patchTransaction(record.id, 'RESEND_CALLBACK')"/>
                </a-tooltip>
              </template>
            </template>

            <template v-if="record.service_type === service.TRANSACTION_SERVICE_REVERSAL">
              <template v-if="record.status === 'success'">
                <a-tooltip title="Reverse Reversal">
                  <a-popconfirm title="Are you sure?" ok-text="Yes" cancel-text="No" @confirm="patchTransaction(record.id, 'REVERSE_REVERSAL')">
                    <a-button :loading="patching.includes(record.id)" size="small" icon="undo" />
                  </a-popconfirm>
                </a-tooltip>
              </template>
            </template>

            <a-tooltip title="Source">
              <a-button size="small" icon="code" @click="() => modal = { visible: true, item: record }"/>
            </a-tooltip>

            <a-tooltip title="Transaction Detail">
              <a-button size="small" icon="ellipsis" :href="routeUri('hyperion.transaction.show', { transaction_uuid: record.id })"/>
            </a-tooltip>
          </div>
        </a-table>
      </a-skeleton>

      <a-modal title="Source" v-model="modal.visible" @ok="() => modal = { visible: false, item: {} }">
        <div class="code-bg">
          <vue-json-pretty :data="modal.item" :deep="1"/>
          <div class="extra">
            <a-button type="link" icon="copy" size="small" @click="copy(JSON.stringify(modal.item, null, 1), 'Source has been successfully copied to your clipboard.')"/>
          </div>
        </div>
      </a-modal>
    </a-card>

    <a-drawer :width="720" placement="right" :closable="true" :visible="drawerVisible" @close="closeDrawer">
      <template v-if="drawerStatus.filtering">
        <h-transaction-filter v-if="showFilter" :filters="filters" :excludes="excludes" @filtered="filtered" />
      </template>
      <template v-else-if="drawerStatus.editing">
        <h-transaction-edit :item="editing" />
      </template>
    </a-drawer>
  </div>
</template>
